var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12", sm: "4" } },
        [
          _c("w-select", {
            attrs: { items: _vm.notificationTypes },
            model: {
              value: _vm.reminder.method,
              callback: function ($$v) {
                _vm.$set(_vm.reminder, "method", $$v)
              },
              expression: "reminder.method",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", sm: "3" } },
        [
          _c("w-input-number", {
            staticClass: "extra",
            attrs: { decimals: 0 },
            on: {
              blur: function ($event) {
                return _vm.updateReminderMinutes()
              },
            },
            model: {
              value: _vm.reminderTime,
              callback: function ($$v) {
                _vm.reminderTime = $$v
              },
              expression: "reminderTime",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", sm: "5" } },
        [
          _c(
            "w-row",
            { attrs: { "no-margin": "" } },
            [
              _c("w-select", {
                style: { flexGrow: 1, flexShrink: 1 },
                attrs: { items: _vm.notificationTimeSpan },
                on: {
                  input: function ($event) {
                    return _vm.updateReminderMinutes()
                  },
                },
                model: {
                  value: _vm.reminderTimeSpan,
                  callback: function ($$v) {
                    _vm.reminderTimeSpan = $$v
                  },
                  expression: "reminderTimeSpan",
                },
              }),
              _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("delete-reminder"),
                      expression: "$ct('delete-reminder')",
                    },
                  ],
                  staticClass: "danger",
                  style: { flexGrow: 0, flexShrink: 0 },
                  attrs: { flat: "" },
                  on: {
                    click: function ($event) {
                      return _vm.remove()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "trash" } })],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }